/* global gapi */
/* global google */

import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { GoogleDriveErrorDialog } from './dialogs';
import variables from '../../common/variables';

const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;
const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;

const DISCOVERY_DOCS = [
  'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
];

const SCOPES =
  'https://www.googleapis.com/auth/drive.install https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile';

const DEFAULT_THUMBNAIL =
  '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';

export const createDriveFile = (presentationName, thumbnail, parents) => {
  const resource = {
    name: presentationName,
    mimeType: 'application/vnd.google-apps.drive-sdk',
    contentHints: {
      thumbnail: {
        image: (thumbnail || DEFAULT_THUMBNAIL)
          .replace(/\+/g, '-')
          .replace(/\//g, '_'),
        mimeType: 'image/png',
      },
    },
    parents,
  };

  return gapi.client.drive.files
    .create({
      resource,
      supportsAllDrives: true,
    })
    .then(response => {
      if (response.status !== 200) {
        throw response;
      }
      return response.result;
    });
};

export const updateDriveFile = (fileId, resource) => {
  return gapi.client.drive.files
    .update({
      fileId,
      resource,
      supportsAllDrives: true,
    })
    .then(response => {
      if (response.status !== 200) {
        throw response;
      }
      return response.result;
    });
};

export const deleteDriveFile = fileId => {
  return gapi.client.drive.files
    .delete({
      fileId,
      supportsAllDrives: true,
    })
    .then(response => {
      if (response.status !== 204) {
        throw response;
      }
      return response.result;
    });
};

export const renameDriveFile = (fileId, name) => {
  return gapi.client.drive.files
    .update({
      fileId,
      resource: {
        name,
      },
      supportsAllDrives: true,
    })
    .then(response => {
      if (response.status !== 200) {
        throw response;
      }
      return response.result;
    });
};

export const useGoogleAPI = () => {
  const [client, setClient] = useState(null);
  const [user, setUser] = useState(null);
  const [pickerInited, setPickerInited] = useState(false);
  const [gisInited, setGisInited] = useState(false);

  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = 'https://apis.google.com/js/api.js';

    const script2 = document.createElement('script');
    script2.src = 'https://accounts.google.com/gsi/client';

    script1.onload = () => {
      gapi.load('client', async () => {
        await gapi.client.init({
          apiKey: GOOGLE_API_KEY,
          discoveryDocs: DISCOVERY_DOCS,
        });
        gapi.load('picker', () => {
          setPickerInited(true);
        });
      });
    };

    script2.onload = () => {
      const client = google.accounts.oauth2.initTokenClient({
        client_id: GOOGLE_CLIENT_ID,
        scope: SCOPES,
        callback: response => {
          setUser({ accessToken: response.access_token });
        },
      });
      setClient(client);
      setGisInited(true);
    };

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);

  const signIn = () => {
    client.requestAccessToken();
  };

  return {
    user,
    signIn,
    isReady: pickerInited && gisInited,
    createDriveFile,
    updateDriveFile,
    deleteDriveFile,
    renameDriveFile,
  };
};

export const GoogleType = PropTypes.shape({
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }),
  isReady: PropTypes.bool,
  signIn: PropTypes.func,
  createDriveFile: PropTypes.func,
});

export const GoogleDriveActionType = PropTypes.shape({
  userId: PropTypes.string,
  folderId: PropTypes.string,
});

const AUTHENTICATION_STATUS = {
  NO_GOOGLE_USER: 'NO_GOOGLE_USER',
  USER_ID: 'USER_ID',
  USER_EMAIL: 'USER_EMAIL',
  OK: 'OK',
};

export const withGoogleDriveActions = Component => props => {
  const {
    user,
    signIn,
    createDriveFile,
    updateDriveFile,
    deleteDriveFile,
    renameDriveFile,
  } = useGoogleAPI();
  return (
    <Component
      googleUser={user}
      signIn={signIn}
      createDriveFile={createDriveFile}
      updateDriveFile={updateDriveFile}
      deleteDriveFile={deleteDriveFile}
      renameDriveFile={renameDriveFile}
      {...props}
    />
  );
};

export const withGoogleAPI = Component => props => {
  // eslint-disable-next-line react/prop-types
  const me = useMemo(() => props.context.me, [props.context.me]);

  const google = useGoogleAPI();
  const driveState = useMemo(
    () =>
      // eslint-disable-next-line react/prop-types
      JSON.parse(new URLSearchParams(props.location.search).get('state')) || {},
    // eslint-disable-next-line react/prop-types
    [props.location],
  );

  const status = useMemo(() => {
    if (driveState.userId) {
      if (!google.user) {
        return AUTHENTICATION_STATUS.NO_GOOGLE_USER;
      } else if (driveState.userId !== google.user.id) {
        return AUTHENTICATION_STATUS.USER_ID;
      } else if (me.email !== google.user.email) {
        return AUTHENTICATION_STATUS.USER_EMAIL;
      }
    }
    return AUTHENTICATION_STATUS.OK;
  }, [google.user && google.user.id, driveState, me]);

  if (!google.isReady) {
    return null;
  }

  switch (status) {
    case AUTHENTICATION_STATUS.NO_GOOGLE_USER:
      return (
        <GoogleDriveErrorDialog
          message={variables.errors.drive.noGoogleUser}
          onAction={google.signIn}
        />
      );
    case AUTHENTICATION_STATUS.USER_ID:
      return (
        <GoogleDriveErrorDialog
          message={variables.errors.drive.userIdDoesNotMatch}
          onAction={() => (window.location.href = '/logout')}
        />
      );
    case AUTHENTICATION_STATUS.USER_EMAIL:
      return (
        <GoogleDriveErrorDialog
          message={variables.errors.drive.userEmailDoesNotMatch}
          onAction={() => (window.location.href = '/logout')}
        />
      );
    default:
      return <Component google={google} driveState={driveState} {...props} />;
  }
};
